module.exports = __webpack_public_path__ + "img/971.42a6bbe9.png";